function BigEllipse() {
  return (
    <svg
      width={1024}
      height={1014}
      viewBox="0 0 1024 1014"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        style={{ mixBlendMode: "lighten" }}
        opacity="0.1"
        filter="url(#filter0_f_224_1615)"
      >
        <ellipse
          cx={512}
          cy={507}
          rx={323}
          ry={318}
          fill="url(#paint0_radial_224_1615)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_224_1615"
          x="0.5"
          y="0.5"
          width={1023}
          height={1013}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="94.25"
            result="effect1_foregroundBlur_224_1615"
          />
        </filter>
        <radialGradient
          id="paint0_radial_224_1615"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(512 507) rotate(90) scale(318 323)"
        >
          <stop stopColor="#2689FF" />
          <stop offset={1} stopColor="#175299" stopOpacity={0} />
        </radialGradient>
      </defs>
    </svg>

  );
}

export default BigEllipse;